(function () {
  const form = document.querySelector('.product__info-wrapper form[action="/cart/add"]');
  if (!form) return;

  const submitButton = form.querySelector('[type="submit"]');
  if (!submitButton) return;

  const sticky = document.createElement('div');
  sticky.className = 'fj-sticky-atc';

  const stickyButton = document.createElement('button');
  stickyButton.type = 'button';
  stickyButton.className = 'fj-sticky-atc__btn';
  sticky.appendChild(stickyButton);
  document.body.appendChild(sticky);

  function syncButton() {
    const label = submitButton.textContent.trim();
    stickyButton.textContent = label || 'Legg i handlekurv';
    stickyButton.disabled = submitButton.disabled;
    if (submitButton.disabled) {
      sticky.classList.remove('is-visible');
    }
  }

  stickyButton.addEventListener('click', () => {
    if (submitButton.disabled) {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    submitButton.click();
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const shouldShow = !entry.isIntersecting;
        sticky.classList.toggle('is-visible', shouldShow && !submitButton.disabled);
      });
    },
    { rootMargin: '0px 0px -40% 0px' }
  );

  observer.observe(form);
  syncButton();

  const mutation = new MutationObserver(syncButton);
  mutation.observe(submitButton, { attributes: true, childList: true, subtree: true });
})();
